
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from './provide-verb-explanation';
const mainimage = '/Images/techpeople1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "provideverb" },
];


const ProvideVerb = () => (
  <GrammarPageLayout
    level="B2"
    title="Using the Verb Provide"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Provide Verb Exercises"
    seoDescription="Use provide in technical English and documentation with its common patterns and collocations. B2 level exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="B2"
  />
);

export default ProvideVerb;
